import {
  Box,
  Flex,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSuiteLocationQuery } from 'generated/graphql';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import Header from './Header';

function Suite() {
  const { locationId, suiteNumber } = useParams() as { locationId: string; suiteNumber: string };
  const { loading, data } = useSuiteLocationQuery({
    variables: { id: locationId },
  });

  if (loading || !data) return null;

  const contracts = data.location.contracts.edges.map(edge => edge.node!);

  return (
    <Flex direction="column" height="100%" bg="white" borderRadius="2xl" boxShadow="md">
      <Header suite={suiteNumber} location={data.location} />
      <Box p={8}>
        <Heading as="h4" size="md" mb={8}>
          <FontAwesomeIcon icon={['fal', 'file-contract']} /> Contracts
        </Heading>
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>client name</Th>
                <Th>client since</Th>
                <Th>contract start</Th>
                <Th>contract end</Th>
              </Tr>
            </Thead>
            <Tbody>
              {contracts
                .filter(contract => contract.suite === parseInt(suiteNumber, 10))
                .map(contract => (
                  <Tr>
                    <Td>{contract.client.fullName}</Td>
                    <Td>{moment(contract.client.createdAt).format('ll')}</Td>
                    <Td>{moment(contract.startOn).format('ll')}</Td>
                    <Td>{moment(contract.endOn).format('ll')}</Td>
                  </Tr>
                ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </Flex>
  );
}
export default Suite;
